import React from "react";
import { Link } from 'react-router-dom'

const HomeText = () => {
    return (
        <div className="homeText">
            <div className="homeTextTop">
                <div className="eyebrow">Software Engineer</div>

                <h1 className="homeTitle">Christina M. Park</h1>

                <p className="homeSubtitle">
                    Building thoughtful digital products at the intersection of
                    technology, people, and creativity.
                </p>

                <div className="homeActions">
                    <Link className="btn-dark" to="/project">View My Work →</Link>
                    <a className="homeTextLink" target="_blank" rel="noreferrer"
                       href="https://www.linkedin.com/in/meet-christina-park/">LinkedIn</a>
                    <a className="homeTextLink" target="_blank" rel="noreferrer"
                       href="https://github.com/christinapark0117">GitHub</a>
                    <a className="homeTextLink" href="https://drive.google.com/file/d/1-WRYTW2S2rnOLXtiCtL-kodQ-sRgqfw8/view?usp=sharing" rel="noreferrer">Resume</a>
                </div>
            </div>

            <div className="homeTextBottom">
                <div className="homeQuote script-quote">
                    <span className="homeQuoteLine">"Different experiences lead to a different perspective.</span>
                    <span className="homeQuoteLine">And that perspective is what makes me stand out."</span>
                </div>
            </div>
        </div>
    )
}

export default HomeText